import React from "react";
import { useParams } from "react-router-dom";
import Breadcrumbs from "../../../Breadcrumbs/Breadcrumbs.js";
import data from "../../../Data/specialists/specialistsData.json";

export default function SpecialistsDetail() {
  const { slug } = useParams();
  const person = data.find((p) => p.slug.toString() === slug);

  if (!person) {
    return <p>Сотрудник не найден</p>;
  }

  return (
    <section className="contacts education staff-detail">
      <Breadcrumbs />
      <div className="staff-detail__wrapper">
        <div className="staff-detail__photo">
          <img src={person.photo} alt={person.name} />
        </div>
        <div className="staff-detail__info">
          <h1 className="staff-detail__name">{person.name}</h1>
          <h2 className="staff-detail__position">{person.position}</h2>
          {person.bio && (
            <div className="staff-detail__bio">
              {person.bio.map((block, index) => (
                <p key={index}>{block}</p>
              ))}
            </div>
          )}
        </div>
      </div>
    </section>
  );
}
